import { render, staticRenderFns } from "./contactlists.vue?vue&type=template&id=2de5b7b6&scoped=true"
import script from "./contactlists.vue?vue&type=script&lang=js"
export * from "./contactlists.vue?vue&type=script&lang=js"
import style0 from "./contactlists.vue?vue&type=style&index=0&id=2de5b7b6&prod&lang=css"
import style1 from "./contactlists.vue?vue&type=style&index=1&id=2de5b7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5b7b6",
  null
  
)

export default component.exports